/* activity.icon.svg.js */

module.exports = {
    icon: `    
            <svg viewBox="0 0 16 16" preserveAspectRatio="none">
            
            <polygon class="foreground-gl" points="8.5,16 6.1,8.3 5.3,9.8 0,9.8 0,8.5 4.5,8.5 6.5,5.1 8.1,10.4 9.9,0 11.9,8.5 16,8.5 16,9.8 10.9,9.8 
                10.1,6.5 "/>
            </svg>
         `
};
